import styled, { css } from 'styled-components';
import { HeaderType } from '@utils/types';
import theme from '@styles/theme';

type TableRowProps = {
    NO_BORDER?: boolean;
    SCROLL?: boolean;
    header: HeaderType[];
};

const TableHeader = ({ NO_BORDER, SCROLL, header = [] }: TableRowProps) => {
    return (
        <TableRow $noBorder={NO_BORDER} $scroll={SCROLL}>
            {header.map((header: HeaderType, index: number) => {
                return (
                    <TableCell
                        key={`${index}-table-header`}
                        $minWidth={header.minWidth}
                        $width={header?.width as number}
                    >
                        {header.label}
                    </TableCell>
                );
            })}
        </TableRow>
    );
};

export default TableHeader;

const TableRow = styled.div<{ $noBorder?: boolean; $scroll?: boolean }>`
    width: inherit;
    height: 50px;
    display: flex;
    align-items: center;
    font-size: 14px;
    border-top: 1px solid ${theme.colors.ultraLightGrayBorder};
    border-bottom: 1px solid ${theme.colors.ultraLightGrayBorder};

    ${({ $noBorder }) =>
        $noBorder &&
        css`
            border-top: none;
        `};

    ${({ $scroll }) =>
        $scroll &&
        css`
            width: fit-content;
        `};
`;

const TableCell = styled.div<{
    $minWidth: number;
    $width: number;
    $fontColor?: string;
}>`
    min-width: ${({ $minWidth }) => $minWidth}px;
    width: ${({ $width, $minWidth }) =>
        $width ? `${$width}%` : `${$minWidth}px`};
    padding-right: 20px;
    font-family: 'PretendardRegular', sans-serif;
    color: ${({ $fontColor }) =>
        $fontColor ? $fontColor : theme.colors.deepGrayFontColor};

    &:first-child {
        padding-left: 20px;
    }
`;
